
import { useEffect, useState } from 'react';
import { Button, Dimmer, Form, Loader, Message, TextArea } from 'semantic-ui-react';
import './Apply.css';
import EastIcon from '@mui/icons-material/East';
import logoSP from "../../images/glowgif01.gif";

const options = [
  { key: '0', text: 'Java Developer', value: 'Java Developer' },
  { key: '1', text: 'React js Developer', value: 'React js Developer' },
  { key: '2', text: 'Python Developer', value: 'Python Developer' },
  { key: '3', text: '.NET Developer', value: '.NET Developer' },
  // { key: '4', text: 'Intermediat', value: 'Intermediat' },
]


export const Apply = () => {
  const [showErrMsg, setShowErrMsg] = useState<string | null>(null);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [form, setForm] = useState<{
    fullName: string,
    contactNo: string,
    emailId: string,
    role:string,
    about: string
  }>({
    fullName: "",
    contactNo: "",
    emailId: "", 
    role: "",
    about: "",
  })

  useEffect(() => {
    if (showSuccessMsg) {
      setTimeout(() => {
        setShowSuccessMsg(false);
      },2000)
    }
  }, [showSuccessMsg])
  const handleChange = (e: any, {value, name}: any) => {
    setForm({
      ...form,
      [name]: value
    })
  }

  const submitForm = async () => {
    let url = process.env.REACT_APP_FORM_URL2;
    if (!url) {
      return;
    }

    url = url.replace("{{FullName}}", form.fullName);
    url = url.replace("{{ContactNo}}", form.contactNo);
    url = url.replace("{{EmailID}}", form.emailId);
    url = url.replace("{{Role}}", form.role);
    url = url.replace("{{About}}", form.about);
    setShowLoader(true);
    const iframe = document.createElement('iframe')
    iframe.src = url;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    setTimeout(() => {
      document.body.removeChild(iframe);
      setShowLoader(false);
      setForm({
        fullName: "",
        contactNo: "",
        emailId: "",
        role:"",
        about: ""  
      })
      setShowSuccessMsg(true);
    }, 1000)
  }

  const validator = (name: string, value: string) => {
    switch(name) {
      case "fullName":
        return value.length >= 3;
      case "collegeName":
        return value.length >= 3;
      case "contactNo":
        return String(value)
          .toLowerCase()
          .match(
            /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
          );
      case "emailId":
        return String(value)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
        }
  }

  const handleSubmit = async () => {
    if (form.fullName && form.about && form.contactNo && form.emailId) {
      if (!validator("fullName", form.fullName)) {
        setShowErrMsg("Full Name should be atleast 3 characters");
        return;
      }

     

      if (!validator("contactNo", form.contactNo)) {
        setShowErrMsg("Invalid Contact No");
        return;
      }

      if (!validator("emailId", form.emailId)) {
        setShowErrMsg("Invalid Email Id");
        return;
      }
      if (!validator("collegeName", form.role)) {
        setShowErrMsg("select one role");
        return;
      }
      if (!validator("collegeName", form.about)) {
        setShowErrMsg("About should be atleast 3 characters");
        return;
      }

      setShowErrMsg(null);
      await submitForm();
    } else {
      setShowErrMsg("* fields are required")
    }
  }

  return (
    <div className='apply' >
      <div  className='apply__left1'>
      <div className='des_image21' 
      // style={{ backgroundImage: `url(${bgImage1})`, backgroundSize: 'cover', background: 'cover' }}
      >
    <div className='des_imagein21'>
  <img src={logoSP} alt='Qshikshak' className='icon21'   />
  <div>
  <div  className='title'>Jobs For You.</div>
  <div className='role' >Java Developer</div>
  <div className='role'  >React js Developer</div>
  <div className='role'  >Python Developer</div>
  <div className='role'  >.NET Developer</div>

  </div>
  </div>
  </div>
      <div className='apply__right'>
        <div style={{color:'black',fontSize:30,fontFamily:'inria',paddingBottom:20}}>Apply Here</div>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            fluid
            className='input'
            // label='Full Name*'
            placeholder='Full Name'
            name="fullName"
            onChange={handleChange}
            value={form.fullName}
          />
        
          <Form.Input
            fluid
            // label='Contact No*'
            placeholder='Contact No'
            name="contactNo"
            onChange={handleChange}
            value={form.contactNo}
          />
          <Form.Input
            // fluid label='Email Id*'
            placeholder='Email Id'
            name="emailId"
            onChange={handleChange}
            value={form.emailId}
          />
            <Form.Select
            fluid
            // label='Role'
            options={options}
            placeholder='Role'
            name="role"
            onChange={handleChange}
            value={form.role}
          />

         <Form.Field
            control={TextArea}
            // label='About'
            placeholder='...'
            name="about"
            onChange={handleChange}
            value={form.about}
          />
          {showErrMsg && <div style={{color: "red"}}>{showErrMsg}</div>}
          <Dimmer active={showLoader}>
            <Loader />
          </Dimmer>
          <div className='apply__btn'>
            <Form.Field  control={Button}  className='button'>
              Submit
              <EastIcon className='arrow' ></EastIcon>
            </Form.Field>
          </div>
        </Form>
        {showSuccessMsg && <Message positive>
          <Message.Header>Application successfully submitted!!</Message.Header>
        </Message>}
      </div>
      </div>
    </div>
  )
}